import { getAuthAxiosBackend } from "../helpers/axios"

class ContactServices{

    get(id){
        return getAuthAxiosBackend().get('Contacts/getContacts/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('Contacts/getContactsByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('Contacts/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('Contacts/addContacts', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('Contacts/updateContacts/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('Contacts/softDeleteContacts/' + id.toString())
    }
}

export default new ContactServices()